import React from 'react';
import ContactManager from '../../components/admin/ContactManager';

const Contact: React.FC = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-primary-900">Contact Information</h1>
        <p className="text-primary-600 mt-2">
          Manage the contact information displayed on the Contact page.
        </p>
      </div>
      
      <ContactManager />
    </div>
  );
};

export default Contact; 